import type { ThunkAction, APIError } from '../../types/app.types';

/*************************************************************************
 * Types
 **************************************************************************/
export type HowItWorksType = {
  step: string;
  title: string;
  description: string;
  imageName: string;
};
export type ValuePropsType = {
  text: string;
  description: string;
  imageName: string;
  footNote: string;
};
export type whyBlinkOptionsType = {
  defaultValueProps: Array<ValuePropsType>;
  defaultValuePropsNoConvenience: Array<ValuePropsType>;
  insuranceValueProps: Array<ValuePropsType>;
  insuranceValuePropsNoConvenience: Array<ValuePropsType>;
};
export type ValuePropsCtaType = {
  text: string;
  iconName: string;
};
type ProductDescription = {
  web: string;
  mobile: string;
};
export type FullFillmentOptionContentType = {
  howItWorks: Array<HowItWorksType>;
  productDescription?: ProductDescription;
  whyBlink: whyBlinkOptionsType;
  valuePropositionsCta: Array<ValuePropsCtaType>;
  pharmaValuePropositionsCta?: Array<ValuePropsCtaType>;
  title: string;
  label: string;
  imageName: string;
};
export type FullFillMentOptionsContentType = {
  homeDelivery: FullFillmentOptionContentType;
  localPickup: FullFillmentOptionContentType;
  telehealth: FullFillmentOptionContentType;
  localPickupWithQuicksave: FullFillmentOptionContentType;
  homeDeliveryWithInsurance: FullFillmentOptionContentType;
};
export type MDVContentType = {
  whyBlink: whyBlinkOptionsType;
  fulfillmentOptions: FullFillMentOptionsContentType;
  faqs: {
    defaultFaqs: Array<{
      question: string;
      answer: string;
      onlyWithInsurance: boolean;
    }>;
  };
};
export type PageContentTypes = MDVContentType;
export type FetchPageContent = {
  type: 'content/FETCH_PAGE_CONTENT';
  res: PageContentTypes;
};
export type ErrorFetchingContent = {
  type: 'content/ERROR_FETCHING_CONTENT';
  res: APIError;
};
export type SetFetching = {
  type: 'content/SET_FETCHING';
};
// Actions
export type PageContentAction = FetchPageContent | SetFetching | ErrorFetchingContent;
export type PageContentState = {
  content: PageContentTypes | null | undefined;
  isFetching: boolean;
};

/*************************************************************************
 * Initial Page Content State
 **************************************************************************/
export const initialState: PageContentState = {
  content: null,
  isFetching: false,
};
export function setFetching(): SetFetching {
  return {
    type: 'content/SET_FETCHING',
  };
}
export function fetchPageContent(contentType: string): ThunkAction<Promise<any>> {
  return function (dispatch, getState, { blinkAPIClient }): Promise<any> {
    dispatch(setFetching());
    return blinkAPIClient
      .get(`/v2/content/${contentType}`)
      .then((res) => res.data)
      .then((data) =>
        dispatch({
          type: 'content/FETCH_PAGE_CONTENT',
          res: data.result,
        })
      )
      .catch((err: APIError) =>
        dispatch({
          type: 'content/ERROR_FETCHING_CONTENT',
          res: err,
        })
      );
  };
}
/*************************************************************************
 * Reducer
 **************************************************************************/

export default function pageContentReducer(
  state: PageContentState = { ...initialState },
  action: PageContentAction
): PageContentState {
  switch (action.type) {
    case 'content/SET_FETCHING': {
      return { ...state, isFetching: true };
    }

    case 'content/FETCH_PAGE_CONTENT': {
      return { ...state, isFetching: false, content: action.res };
    }

    case 'content/ERROR_FETCHING_CONTENT': {
      return { ...state, isFetching: false, content: null };
    }

    default:
      return state;
  }
}
